import React, {useEffect, useReducer, useState} from "react";
import $ from "jquery";
import PropTypes from "prop-types";

import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

import MaterialSpinner from "../../ui/materialSpinner";
import ActionTypes from "../../../misc/actionTypes";
// import LookLayoutsVirtualizedList from "./lookLayoutsVirtualizedList";
import {getRoomLayouts} from "../lookNavigation/lookFunctions";
import LookLayoutItem from "./lookLayoutItem";
import Config from "../../../config";

const LookLayoutMain = (props) => {

  const {popupCloseClick} = props;

  const [looks, setLooks] = useState([]); // {lookLayout, lookScene}
  const [showAllLayouts, setShowAllLayouts] = useState(false); // {lookLayout, lookScene}
  const [, forceUpdate] = useReducer(x => x + 1, 0);

  const updateMain = () => {
    forceUpdate(1)
  }

  useEffect(() => {
    setLooks(getRoomLayouts());
    $(window).on(ActionTypes.CHANGE_LAYOUT, updateMain);
    return () => {
      $(window).off(ActionTypes.CHANGE_LAYOUT, updateMain);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!looks.length) {
    return (
      <div className="ll-main">
        <MaterialSpinner/>
      </div>
    )
  }

  const checkboxClick = (event) => {
    setShowAllLayouts(event.target.checked);
    setLooks(getRoomLayouts(event.target.checked));
  }

  return (
    <div className="ll-main">
      {Config.isVisualizerManagement() ? (
        <p>
          <FormControlLabel
            label={"Show All Available Layouts"}
            className="g-filters__item"
            control={<Checkbox checked={showAllLayouts} onChange={checkboxClick} />}
          />
        </p>
      ) : null}
      <ul className="ll-layouts">
        {/*<LookLayoutsVirtualizedList renderList={looks}/>*/}
        {looks.map((look, lookIndex) => {
          return <LookLayoutItem key={lookIndex} look={look} popupCloseClick={popupCloseClick}/>
        })}
      </ul>
    </div>
  )
};

LookLayoutMain.propTypes = {
  popupCloseClick: PropTypes.func.isRequired
}

export default LookLayoutMain
